var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.source != null)?_c('div',{staticClass:"flex text-sm pr-4"},[_c('div',[_c('router-link',{attrs:{"to":'/chats/' + _vm.source.supportChat}},[_vm._v(" "+_vm._s(_vm.getFullname(_vm.source))+" ")])],1),_c('div',{staticClass:"ml-auto"},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.source.phone))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }